/* KRONEKS: broaden search matching without breaking exact SKU lookups.

   Two jobs:
   1. Cyrillic brand names typed the way Bulgarian customers type them
      ("касио", "фосил", "джи шок") are rewritten to what the catalogue
      actually stores ("casio", "fossil", "g-shock").
   2. Casio-style model refs typed without the dash ("mdv107") are rewritten
      to the catalogue's dashed form ("mdv-107").

   Job 2 is LIMITED to the letter prefixes that our own catalogue writes with a
   dash (DASHED_PREFIXES, Casio/Citizen/Orient families). Dashing everything —
   the previous behaviour — silently broke every brand whose SKU has no dash:
   "FS5699", "DZ4417", "VS59J007Y" became "FS-5699" etc. and returned ZERO
   results, and partial typing ("GW047" -> "GW-047") died the same way.

   Never "original OR variant": Shopify's /search returns 0 for "e740 OR e-740".
   Instead krQueryVariants() lists the forms to try one after another, and the
   callers fall back to the next form only when a form finds nothing:
   predictive-search.js while typing, main-search.liquid on a 0-result page. */
(function () {
  var ALIASES = {
    gshock: 'g-shock',
    джишок: 'g-shock',
    жишок: 'g-shock',
    касио: 'casio',
    казио: 'casio',
    ситизен: 'citizen',
    ситизън: 'citizen',
    ориент: 'orient',
    секонда: 'sekonda',
    акурист: 'accurist',
    гес: 'guess',
    гесс: 'guess',
    едифайс: 'edifice',
    едифис: 'edifice',
    протрек: 'pro trek',
    фосил: 'fossil',
    фосъл: 'fossil',
    скаген: 'skagen',
    дизел: 'diesel',
    армани: 'armani',
    сейко: 'seiko',
    сеико: 'seiko',
    хед: 'head',
    джуиса: 'jowissa',
    ребека: 'rebecca',
    супердрай: 'superdry',
    полар: 'polar',
    дкни: 'dkny'
  };

  /* Multi-word spellings, replaced before the query is split into tokens. */
  /* Multi-word spellings, replaced before the query is split into tokens.
     `\b` is ASCII-only in JavaScript, so Cyrillic phrases are bounded with an
     explicit (^|\s) ... (?=\s|$) instead — with \b they never matched. */
  var PHRASES = [
    [/(^|\s)джи[\s-]*шок(?=\s|$)/gi, '$1g-shock'],
    [/(^|\s)бейби[\s-]*джи(?=\s|$)/gi, '$1baby-g'],
    [/(^|\s)baby\s+g(?=\s|$)/gi, '$1baby-g'],
    [/(^|\s)g\s+shock(?=\s|$)/gi, '$1g-shock'],
    [/(^|\s)майкъл\s+корс(?=\s|$)/gi, '$1michael kors'],
    [/(^|\s)кю[\s-]*(?:енд[\s-]*)?кю(?=\s|$)/gi, '$1q&q'],
    [/(^|\s)армани\s+ексчейндж(?=\s|$)/gi, '$1armani exchange'],
    [/(^|\s)свис\s+милитари(?=\s|$)/gi, '$1swiss military'],
    [/(^|\s)швейцарски\s+милитари(?=\s|$)/gi, '$1swiss military'],
    [/(^|\s)про\s*трек(?=\s|$)/gi, '$1pro trek'],
    [/(^|\s)кейт\s+спейд(?=\s|$)/gi, '$1kate spade'],
    [/(^|\s)тори\s+бърч(?=\s|$)/gi, '$1tory burch'],
    [/(^|\s)ориент\s+стар(?=\s|$)/gi, '$1orient star']
  ];

  /* Letter prefixes our catalogue writes WITH a dash (Casio & friends).
     Derived from every published SKU/title on 2026-09-20; anything not listed
     here is left exactly as the customer typed it. */
  var DASHED_PREFIXES = [
    'ABL', 'AE', 'AEQ', 'AMW', 'AQ', 'BEM', 'BGD', 'DB', 'DBC', 'DW', 'DWE',
    'ECB', 'EF', 'EFB', 'EFK', 'EFR', 'EFV', 'GA', 'GBA', 'GBD', 'GBM', 'GD',
    'GM', 'LQ', 'LRW', 'LTP', 'LW', 'MDV', 'MQ', 'MRW', 'MTD', 'MTP', 'MW',
    'MWA', 'PRG', 'PRW', 'STR', 'UTP', 'W', 'WS', 'WV'
  ];

  var MODEL = /^([a-z]+)(\d[a-z0-9]*)$/i;
  var DASHED_MODEL = /^([a-z]+)-(\d[a-z0-9]*)$/i;

  function applyPhrases(q) {
    var out = q;
    for (var i = 0; i < PHRASES.length; i++) out = out.replace(PHRASES[i][0], PHRASES[i][1]);
    return out;
  }

  function aliasToken(t) {
    return ALIASES[t.toLowerCase()] || t;
  }

  /* "mdv107" -> "mdv-107", but only for a prefix the catalogue dashes. */
  function dashKnown(t) {
    var m = MODEL.exec(t);
    if (!m || m[1].length > 5) return t;
    return DASHED_PREFIXES.indexOf(m[1].toUpperCase()) === -1 ? t : m[1] + '-' + m[2];
  }

  /* "fs107" -> "fs-107" for ANY prefix (last-resort fallback only). */
  function dashAny(t) {
    var m = MODEL.exec(t);
    return m && m[1].length <= 5 ? m[1] + '-' + m[2] : t;
  }

  /* "gstb100" -> "gst-b100", "efrs108" -> "efr-s108": Casio families whose model
     starts with a letter after the dash, typed as one word (fallback only). */
  function dashInner(t) {
    var m = /^([a-z]{2,4})([a-z]\d[a-z0-9]*)$/i.exec(t);
    return m ? m[1] + '-' + m[2] : t;
  }

  /* "fs-5699" -> "fs5699" (last-resort fallback only). */
  function undash(t) {
    var m = DASHED_MODEL.exec(t);
    return m ? m[1] + m[2] : t;
  }

  function rewrite(q, tokenFn) {
    return applyPhrases(q.trim())
      .split(/\s+/)
      .map(function (t) {
        return tokenFn(aliasToken(t));
      })
      .join(' ');
  }

  /* The query we actually submit: safe aliases + dashes only where the
     catalogue uses them. */
  window.krExpandQuery = function (q) {
    if (!q) return q;
    var trimmed = q.trim();
    if (!trimmed || / OR /i.test(trimmed)) return q;
    var normalized = rewrite(trimmed, dashKnown);
    return normalized === trimmed ? q : normalized;
  };

  /* Every form worth trying, best first. Callers stop at the first one that
     returns results. */
  window.krQueryVariants = function (q) {
    if (!q) return [];
    var trimmed = q.trim();
    if (!trimmed || / OR /i.test(trimmed)) return [q];
    var list = [
      rewrite(trimmed, dashKnown),
      trimmed,
      rewrite(trimmed, dashAny),
      rewrite(trimmed, dashInner),
      rewrite(trimmed, undash)
    ];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && out.indexOf(list[i]) === -1) out.push(list[i]);
    }
    return out;
  };

  /* An OR query that matched this many products matched the whole catalogue:
     Shopify's /search is OR, never AND ("zzzz часовник" returns 1000 too), and
     the AND operator is ignored. A quoted phrase is the only thing that
     narrows, so a broad multi-word query is retried as a phrase. */
  var BROAD_RESULTS = 200;
  /* Below this a phrase is too literal to be useful — "черен часовник" matches
     3 titles while the shop has hundreds of black watches — so the plain, broad
     results are the better answer after all. */
  var MIN_PHRASE_RESULTS = 5;

  function isQuotable(q) {
    return /\s/.test(q) && q.indexOf('"') === -1;
  }

  function goTo(params, query, extra) {
    params.set('q', query);
    for (var key in extra) params.set(key, extra[key]);
    window.location.replace(window.location.pathname + '?' + params.toString());
  }

  /* The phrase form of a multi-word query, or null. Shopify ORs the words, so
     the phrase is the only way to keep "детски часовник" from matching every
     product that merely says "часовник". */
  window.krPhraseVariant = function (q) {
    var normalized = window.krExpandQuery(q);
    if (!normalized) return null;
    normalized = normalized.trim();
    return isQuotable(normalized) ? '"' + normalized + '"' : null;
  };

  /* Enough products behind a phrase for it to beat the broad results. */
  window.krMinPhraseResults = MIN_PHRASE_RESULTS;

  /* Called by main-search.liquid on every search page.
     - nothing found            -> reload on the next spelling in the list
     - found on a spelling we can improve (a brand typed in Cyrillic, a model
       ref the catalogue dashes) -> reload on that one
     - a multi-word query that matched half the shop -> reload it as a phrase,
       and come back to the broad results if the phrase is too literal
     Every step is taken at most once (?kr_t=, ?kr_q=), so a search that really
     matches nothing, or that is already as good as it gets, stops here. */
  window.krSearchFallback = function (terms, resultsCount) {
    var params = new URLSearchParams(window.location.search);
    // The URL is the honest copy of the query: Liquid hands us the terms
    // HTML-escaped, so a phrase would come back as &quot;…&quot;.
    var current = (params.get('q') || '').trim() || (terms || '').trim();
    var phraseTried = params.get('kr_q');
    var plain = params.get('kr_p');

    krShowPlainTerms(plain, current);

    if (current.indexOf('"') !== -1) {
      // Already a phrase. Either it stands on its own or we go back to the
      // broad results — never re-spell a quoted query.
      if (phraseTried === '1' && plain && resultsCount < MIN_PHRASE_RESULTS) {
        params.delete('kr_p');
        goTo(params, plain, { kr_q: '0' });
      }
      return;
    }

    var variants = window.krQueryVariants(current);
    if (!variants.length) return;
    var visited = params.has('kr_t') ? parseInt(params.get('kr_t'), 10) : -1;

    if (resultsCount === 0) {
      var next = Math.max(visited, variants.indexOf(current)) + 1;
      if (next >= variants.length || variants[next] === current) return;
      goTo(params, variants[next], { kr_t: String(next) });
      return;
    }

    // A spelling we know how to improve, e.g. a Cyrillic brand name.
    if (visited < 0 && variants[0] !== current) {
      goTo(params, variants[0], { kr_t: '0' });
      return;
    }

    // Matched everything: Shopify ORs the words together, so narrow to a phrase.
    if (!phraseTried && resultsCount >= BROAD_RESULTS && isQuotable(current)) {
      goTo(params, '"' + current + '"', { kr_q: '1', kr_p: current });
    }
  };

  /* On a page we loaded as a phrase, keep the customer's own words in the
     search boxes and in the "N резултата за …" line — not our quotes. */
  function krShowPlainTerms(plain, current) {
    if (!plain || plain === current) return;

    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      if (input.value.indexOf(plain) !== -1) input.value = plain;
    });

    document.querySelectorAll('[role="status"], .template-search h1, h2').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.indexOf('"' + plain + '"') !== -1) {
        el.textContent = el.textContent.replace('"' + plain + '"', plain);
      }
    });

    document.title = document.title.replace('&quot;' + plain + '&quot;', plain).replace('"' + plain + '"', plain);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) input.value = window.krExpandQuery(input.value);
    },
    true
  );
})();
